export function get(key) {
  const auth = localStorage.getItem(key);
  if (auth) {
    return JSON.parse(auth);
  }
}

export function set(key, data) {
  localStorage.setItem(key, JSON.stringify(data));
}

export function remove(key) {
  localStorage.removeItem(key);
}

export function reset() {
  localStorage.clear();
}
